module.exports = __webpack_public_path__ + "static/media/spoons1.dd56db13.jpg";